// export const VISITORTAGS_TESTING_BASE_URL     = `https://visitor-test-app.icsi.lk`;
// export const VISITORTAGS_PRODUCTION_BASE_URL  = `https://visitor-app.icsi.lk`;
//
// export const TAGS_TESTING_BASE_URL          = `https://test-app.icsi.lk`;
// export const TAGS_PRODUCTION_BASE_URL       = `https://app.icsi.lk`;
//
// export const EVENTTAGS_TESTING_BASE_URL     = `https://event-test-app.icsi.lk`;
// export const EVENTTAGS_PRODUCTION_BASE_URL  = `https://event-app.icsi.lk`;
//
// export const AUTHTAGS_TESTING_BASE_URL      = `https://auth-test-app.icsi.lk`;
// export const AUTHTAGS_PRODUCTION_BASE_URL   = `https://auth-app.icsi.lk`;
//
// export const PARKTAGS_TESTING_BASE_URL      = `https://park-test-app.icsi.lk`;
// export const PARKTAGS_PRODUCTION_BASE_URL   = `https://park-app.icsi.lk`;
//
// export const SPACETAGS_TESTING_BASE_URL     = `https://space-test-app.icsi.lk`;
// export const SPACETAGS_PRODUCTION_BASE_URL  = `https://space-app.icsi.lk`;
// // ------------------

export const VISITORTAGS_TESTING_BASE_URL     = `https://md-visitor-test-app.ceyentra.lk`;
export const VISITORTAGS_PRODUCTION_BASE_URL  = `https://visitor-app.icsi.lk`;

export const TAGS_TESTING_BASE_URL          = `https://md-test-app.ceyentra.lk`;
export const TAGS_PRODUCTION_BASE_URL       = `https://app.icsi.lk`;

export const EVENTTAGS_TESTING_BASE_URL     = `https://md-event-test-app.ceyentra.lk`;
export const EVENTTAGS_PRODUCTION_BASE_URL  = `https://event-app.icsi.lk`;

export const AUTHTAGS_TESTING_BASE_URL      = `https://md-auth-test-app.ceyentra.lk`;
export const AUTHTAGS_PRODUCTION_BASE_URL   = `https://auth-app.icsi.lk`;

export const PARKTAGS_TESTING_BASE_URL      = `https://md-park-test-app.ceyentra.lk`;
export const PARKTAGS_PRODUCTION_BASE_URL   = `https://park-app.icsi.lk`;

export const SPACETAGS_TESTING_BASE_URL     = `http://localhost:3000`;
export const SPACETAGS_PRODUCTION_BASE_URL  = `https://space-app.icsi.lk`;

// NEW SERVER URLs
export const VISITORTAG_API_URL     = (status) => `${status === 1 ? VISITORTAGS_PRODUCTION_BASE_URL  : VISITORTAGS_TESTING_BASE_URL}/api/v1/`;
export const TAG_API_URL            = (status) => `${status === 1 ? TAGS_PRODUCTION_BASE_URL         : TAGS_TESTING_BASE_URL}/api/v1/`;
export const EVENTTAG_API_URL       = (status) => `${status === 1 ? EVENTTAGS_PRODUCTION_BASE_URL    : EVENTTAGS_TESTING_BASE_URL}/api/v1/`;
export const AUTHORIZATION_API_URL  = (status) => `${status === 1 ? AUTHTAGS_PRODUCTION_BASE_URL     : AUTHTAGS_TESTING_BASE_URL}/`;
export const PARK_API_URL           = (status) => `${status === 1 ? PARKTAGS_PRODUCTION_BASE_URL     : PARKTAGS_TESTING_BASE_URL}/api/v1/`;
export const SPACETAG_API_URL       = (status) => `${status === 1 ? SPACETAGS_PRODUCTION_BASE_URL    : SPACETAGS_TESTING_BASE_URL}/api/v1/web`;
// NEW SERVER URLs - END

export const VISITORTAG_URL     =  isProduction() ?  VISITORTAG_API_URL(1)      : VISITORTAG_API_URL(0);
export const TAG_URL            =  isProduction() ?  TAG_API_URL(1)             : TAG_API_URL(0);
export const AUTHORIZATION_URL  =  isProduction() ?  AUTHORIZATION_API_URL(1)   : AUTHORIZATION_API_URL(0);
export const EVENTTAG_URL       =  isProduction() ?  EVENTTAG_API_URL(1)        : EVENTTAG_API_URL(0);
export const PARKTAG_URL        =  isProduction() ?  PARK_API_URL(1)            : PARK_API_URL(0);
export const SPACETAG_URL       =  isProduction() ?  SPACETAG_API_URL(1)        : SPACETAG_API_URL(0);

// ------------- SOCKET ------------------
export const EVENT_SOCKET_API_URL       = (status) => `${status === 1 ? EVENTTAGS_PRODUCTION_BASE_URL     : EVENTTAGS_TESTING_BASE_URL}/api/`;
export const RECEPT_FR_SOCKET_API_URL   = (status) => `${status === 1 ? VISITORTAGS_PRODUCTION_BASE_URL   : VISITORTAGS_TESTING_BASE_URL}/api/`;

export const EVENT_SOCKET_URL       =  isProduction() ?  EVENT_SOCKET_API_URL(1)       : EVENT_SOCKET_API_URL(0);
export const RECEPT_FR_SOCKET_URL   =  isProduction() ?  RECEPT_FR_SOCKET_API_URL(1)   : RECEPT_FR_SOCKET_API_URL(0);

export function isProduction () {
  return true;
  // return window.location.origin.indexOf('https://web.icsi.lk') !== -1;
}
